<template>
  <div class="com-box" :style="{height: isEdit ? null : pagesHeight + 'px'}">
    <div class="front" :class="{'active-front': isEdit}" ref="element">
      <div class="head" v-if="!isApplayTemp">
        <div class="head-left">
          <div class="item" v-if="cmpIndex != 0" @click="moveUp">上移</div>
          <div class="item" v-if="comListLength != cmpIndex" @click="shiftDown">下移</div>
          <div class="item" v-if="comListLength > 0" @click="delCmp">删除</div>
        </div>
        <div class="head-right" @click="edit">编辑</div>
      </div>
      <preview-spike :comData="previewData" v-show="!isEdit" :tmpType="tmpType"/>
    </div>
    <div class="back" :class="{'active-back': isEdit}">
      <spike v-model="formData" :isDit="isEditActivity"/>
      <spike-conf v-model="spikeConf" />
      <div style="height: 60px;"></div>
      <div class="footer">
        <div class="footer-item call" @click="cancel">取消</div>
        <div class="footer-item" @click="save">保存</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import previewSpike from '@/pages/activity-home/components/spike'
import spike from '../../components/spike'
import spikeConf from '../../components/spike-conf'
import {paramesVerification} from '../../utils.js'
import _ from 'loadsh'
export default {
  components: {
    previewSpike,
    spike,
    spikeConf
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: Object,
    spikeSet: Object,
    cmpIndex: Number,
    comListLength: Number,
    isApplayTemp: Boolean,
    tmpType: Number,
  },
  computed: {
    ...mapGetters({
      // 经销商
      isDistributor: 'isDistributor',
      // 店长
      isShopowner: 'isShopowner',
      // 导购
      isGuide: 'isGuide',
      // 活动老师
      isTeacher: 'isTeacher',
    }),
     // 是否编辑
    isEditActivity() {
      return this.$route.query.from == 'manager' ? true : false
    }
  },
  watch: {
    value: {
      handler(newVal) {
        this.previewData = _.cloneDeep(newVal)
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      isEdit: false,
      formData: {},
      spikeConf: {},
      previewData: {},
      pagesHeight: '280',
      cmpHeight: ['280px', '500px']
    }
  },
  mounted() {
    // 获取组件高度
    this.$nextTick(()=> {
      let height = this.$refs.element.offsetHeight;
      this.pagesHeight = height  == '0' ? '280' : height + 10
      console.log(this.pagesHeight)
    })
  },
  methods: {
    edit() {
      this.formData = _.cloneDeep(this.value)
      this.spikeConf = _.cloneDeep(this.spikeSet)
      this.isEdit = true
      this.$emit('handle',['spike',false])
    },
    cancel() {
      this.isEdit = false
      this.$emit('handle', ['spike',true])
    },
    save() {
      // 秒杀参数验证
      const {isAdopt,title} = paramesVerification([{comType: 'spike',formData: this.formData}], 'spike')
      if (!isAdopt) {
        this.$toast(title)
        return
      }
      this.$emit('change', this.formData)
      this.$emit('update:spikeSet', this.spikeConf)
      this.isEdit = false
      this.$nextTick(()=> {
        this.pagesHeight = this.$refs.element.offsetHeight + 10
        this.$emit('handle', ['spike',true])
      })
    },
    delCmp() {
      this.$emit('delCmp',this.cmpIndex)
    },
    moveUp() {
      this.$emit('moveUp',this.cmpIndex)
    },
    shiftDown() {
      this.$emit('shiftDown',this.cmpIndex)
    }
  }
}
</script>

<style lang="stylus" scoped>
.com-box {
  position: relative;
  perspective: 800px;
  overflow hidden
  // padding: 10px 0;
  box-sizing: border-box;
  .front {
    position: absolute;
    left: 0;
    right: 0;
    transition: 1s;
    z-index: 1;
    backface-visibility: hidden;
    margin-top: 10px;
    .head {
      position: absolute;
      top: 10px;
      left: 10px;
      width: 95%;
      display: flex;
      justify-content: space-between;
      z-index: 9;
      z-index: 9;
      .head-left {
        display: flex;
        .item {
          padding: 4px;
          border-radius: 3px;
          background: #fff;
          margin-right: 10px;
        }
      }
      .head-right {
        padding: 4px;
        border-radius: 3px;
        background: #fff;
      }
    }
  }
  .back {
    transform: rotateY(-180deg);
    backface-visibility: hidden;
    transition: 1s;
    margin-top: -10px;
    background: #fff;
    .footer {
      display: flex;
      justify-content center;
      width: 100%;
      padding: 10px 0;
    }
    .footer-item {
      color: #FFFFFF;
      padding: 10px 26px;
      border-radius: 4px;
      background: #FF6B31;
      margin-left: 20px;
    }
    .call {
      color: #FF6B31;
      background: #F4F4F4;
    }
  }
  .active-front {
    transform: rotateY(180deg);
  }
  .active-back {
    transform: rotateY(0deg);
  }
}
  
</style>